(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dws-bundle-builder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.dws-bundle__form').forEach((form) => {
  if (form.dataset.ready) return;
  form.dataset.ready = 'true';
  const total = form.querySelector('.dws-bundle__total');
  const message = form.querySelector('.dws-bundle__message');
  const button = form.querySelector('button[type="submit"]');
  const selectedOption = (select) => select.options[select.selectedIndex];
  const selection = () => {
    const anchor = selectedOption(form.querySelector('.dws-bundle__anchor'));
    const posters = [...form.querySelectorAll('.dws-bundle__card')].filter((card) => card.querySelector('.dws-bundle__check').checked).map((card) => selectedOption(card.querySelector('select')));
    return { anchor, posters };
  };
  const update = () => {
    const { anchor, posters } = selection();
    const cents = [anchor, ...posters].reduce((sum, option) => sum + Number(option.dataset.price), 0);
    total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: form.dataset.currency }).format(cents / 100);
    message.textContent = posters.length ? posters.length + (posters.length === 1 ? ' poster selected.' : ' posters selected.') : 'Choose at least one poster.';
  };
  form.addEventListener('change', update);
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const { anchor, posters } = selection();
    if (!posters.length) { message.textContent = 'Choose at least one poster.'; return; }
    button.disabled = true;
    message.textContent = 'Adding your set…';
    try {
      const items = [anchor, ...posters].map((option) => ({ id: Number(option.value), quantity: 1 }));
      const response = await fetch(form.dataset.cartUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) { const error = await response.json(); throw new Error(error.description || 'Could not add the set.'); }
      window.location.assign(form.dataset.cartPage);
    } catch (error) {
      message.textContent = error.message || 'Could not add the set. Please try again.';
      button.disabled = false;
    }
  });
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function setupDwsCollectionTools() {
    const url = new URL(window.location.href);
    const form = document.querySelector('.dws-collection-tools__filters');
    const routeTags = form
      ? decodeURIComponent(url.pathname).split('/').filter(Boolean).slice(2).join('+').split('+').filter(Boolean)
      : [];
    const selectedTags = [
      ...url.searchParams.getAll('filter.p.tag').flatMap((value) => value.split(',')),
      ...routeTags,
    ];

    for (const tag of selectedTags) {
      const niche = document.querySelector('#dws-poster-niche option[value="' + CSS.escape(tag) + '"]');
      const subgenre = document.querySelector('#dws-poster-subgenre option[value="' + CSS.escape(tag) + '"]');
      if (niche) niche.closest('select').value = tag;
      else if (subgenre) subgenre.closest('select').value = tag;
    }

    const nicheSelect = document.querySelector('#dws-poster-niche');
    const subgenreSelect = document.querySelector('#dws-poster-subgenre');
    if (nicheSelect && subgenreSelect) {
      const syncSubgenres = () => {
        for (const group of subgenreSelect.querySelectorAll('optgroup')) {
          const available = !nicheSelect.value || group.label.toLowerCase() === nicheSelect.value;
          group.disabled = !available;
          group.hidden = !available;
        }
        if (subgenreSelect.selectedOptions[0]?.parentElement.disabled) subgenreSelect.value = '';
      };
      nicheSelect.addEventListener('change', syncSubgenres);
      syncSubgenres();
    }

    if (form && form.dataset.dwsReady !== 'true') {
      form.dataset.dwsReady = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const tags = [...form.querySelectorAll('select')].map((select) => select.value).filter(Boolean);
        window.location.assign(form.action.replace(/\/$/, '') + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : ''));
      });
    }

    if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupDwsCollectionTools, { once: true });
  else setupDwsCollectionTools();

  } catch(e) { console.error(e); }
})();
})();
